import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationCountService {
  private notifCountSubject = new BehaviorSubject<number>(0);
  notifCount$ = this.notifCountSubject.asObservable();

  setCount(count: number) {
    this.notifCountSubject.next(count);
  }
}
